var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"unselect",attrs:{"src":"/static/icon/ic_google_circle.svg"},on:{"click":_vm.login}})}
var staticRenderFns = []

export { render, staticRenderFns }